import { render, staticRenderFns } from "./ImagePhotoJourneyHistorySkeleton.vue?vue&type=template&id=0f021bb8"
import script from "./ImagePhotoJourneyHistorySkeleton.vue?vue&type=script&lang=js"
export * from "./ImagePhotoJourneyHistorySkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports